import React from 'react'
import Helmet from 'react-helmet'

function META({ data, metaData }) {
  return (
    <Helmet title={metaData.title}
      meta={[
        {
          name: `description`,
          content: metaData.description
        },
        {
          name: `keywords`,
          content: metaData.keywords
        },
        {
          property: `og:title`,
          content: metaData.ogTitle
        },
        {
          property: `og:description`,
          content: metaData.ogDescription
        },
        {
          property: `og:url`,
          content: `https://www.visitrestore.com/${metaData.url}`
        },
        {
          property: `og:image`,
          content: metaData.ogImage
        },
        {
          property: `twitter:url`,
          content: `https://www.visitrestore.com/${metaData.url}`
        },
        {
          property: `twitter:image:src`,
          content: metaData.twitterImage
        },
        {
          property: `twitter:title`,
          content: metaData.twitterTitle
        },
        {
          property: `twitter:description`,
          content: metaData.twitterDescription
        }
      ]} />
  )
}

export default META